import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VetroHero from "./sections/VetroHero";
import HeroBanner from "./sections/HeroBanner";
import Standards from "./sections/Standards";
import Portfolio from "./sections/Portfolio";
import ConsultingPillars from "./sections/ConsultingPillars";
import Services from "./sections/Services";
import Highlight from "./sections/Highlight";
import Truststats from "./sections/Truststats";
import ClientPerspectives from "./sections/ClientPerspectives";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VetroHero />
      <HeroBanner />
      <Standards />
      <Portfolio />
      <ConsultingPillars />
      <Services />
      <Highlight />
      <Truststats />
      <ClientPerspectives />
      <Footer />
    </div>;
}